import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'payment.order.history.page.heading': {
    id: 'payment.order.history.page.heading',
    defaultMessage: 'Order History',
    description: 'Page heading for order history.',
  },
  'payment.order.history.no.orders': {
    id: 'payment.order.history.no.orders',
    defaultMessage: 'Orders you place with edX will appear here.',
    description: 'The message displayed when there are no orders.',
  },
  'payment.order.history.orders.loader': {
    id: 'payment.order.history.orders.loader',
    defaultMessage: 'Loading orders...',
    description: 'Message when orders are being loaded',
  },
  'payment.order.history.table.column.items': {
    id: 'payment.order.history.table.column.items',
    defaultMessage: 'Items',
    description: 'The column label for Items in the order history table.',
  },
  'payment.order.history.table.column.date.placed': {
    id: 'payment.order.history.table.column.date.placed',
    defaultMessage: 'Date placed',
    description: 'The column label for Date placed in the order history table.',
  },
  'payment.order.history.table.column.total.cost': {
    id: 'payment.order.history.table.column.total.cost',
    defaultMessage: 'Total cost',
    description: 'The column label for Total cost in the order history table.',
  },
  'payment.order.history.table.column.order.number': {
    id: 'payment.order.history.table.column.order.number',
    defaultMessage: 'Order number',
    description:
      'The column label for Order number in the order history table.',
  },
  'payment.order.history.table.column.order.details': {
    id: 'payment.order.history.table.column.order.details',
    defaultMessage: 'Order details',
    description:
      'The column label for Order details in the order history table.',
  },
  'payment.order.history.page.payment.processor.heading.android': {
    id: 'payment.order.history.page.payment.processor.heading.android',
    defaultMessage: 'Android purchase',
    description: 'The android payment processor heading.',
  },
  'payment.order.history.page.payment.processor.heading.ios': {
    id: 'payment.order.history.page.payment.processor.heading.ios',
    defaultMessage: 'iOS purchase',
    description: 'The ios payment processor heading.',
  },
});
